export { default as HeroStyle } from './Hero.module.scss';
export { default as FeaturedServicesStyle } from './FeaturedServices.module.scss';
export { default as ShortcutCountryListStyle } from './ShortcutCountryList.module.scss';
